import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "success",
  "use": "success-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"success\"><defs><style></style></defs><path d=\"M443.733 785.067L375.467 716.8 170.667 512l68.266-68.267 204.8 204.8L819.2 307.2l68.267 68.267-443.734 409.6zM512 0C229.24 0 0 229.274 0 512c0 282.76 229.24 512 512 512 282.795 0 512-229.24 512-512S794.795 0 512 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id